class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    const allSearchForms = [];
    this.allSearchInputs.forEach((input) => {
      if (input.form) allSearchForms.push(input.form);
    });

    this.input.addEventListener('focus', this.onInputFocus.bind(this));

    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    if (allSearchForms.length < 2) return;

    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('click', this.onInput.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  isSkuLike(query) {
    if (!query) return false;
    if (query.includes(' ')) return false;
    return /\d/.test(query) || /[-_.]/.test(query);
  }

  onFormSubmit(event) {
    const query = this.input.value.trim();
    if (!query) return;

    event.preventDefault();

    const url = new URL(`${window.Shopify.routes.root}search`, window.location.origin);
    url.searchParams.set('type', 'product');

    if (this.isSkuLike(query)) {
      url.searchParams.set('q', `variants.sku:${query}`);
      url.searchParams.set('options[prefix]', 'none');
    } else {
      // Trailing * aligns storefront search with predictive partial matches
      // (e.g. "leverstoot" → "leverstootkussen") where options[prefix]=last alone is not enough.
      const searchQuery = query.endsWith('*') ? query : `${query}*`;
      url.searchParams.set('q', searchQuery);
      url.searchParams.set('options[prefix]', 'last');
    }

    window.location.href = url.toString();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

// class MainSearch extends SearchForm {
//   constructor() {
//     super();
//     this.allSearchInputs = document.querySelectorAll('input[type="search"]');
//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     let allSearchForms = [];
//     this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
//     this.input.addEventListener('focus', this.onInputFocus.bind(this));
//     if (allSearchForms.length < 2) return;
//     allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
//     this.allSearchInputs.forEach((input) => input.addEventListener('click', this.onInput.bind(this)));
//     this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.keepInSync('', this.input);
//     }
//   }

//   onInput(event) {
//     const target = event.target;
//     this.keepInSync(target.value, target);
//   }

//   onInputFocus() {
//     const isSmallScreen = window.innerWidth < 750;
//     if (isSmallScreen) {
//       this.scrollIntoView({ behavior: 'smooth' });
//     }
//   }

//   keepInSync(value, target) {
//     this.allSearchInputs.forEach((input) => {
//       if (input !== target) {
//         input.value = value;
//       }
//     });
//   }
// }

// customElements.define('main-search', MainSearch);
